import { render, staticRenderFns } from "./RoleDeletemodal.vue?vue&type=template&id=a1b19780&scoped=true&"
import script from "./RoleDeletemodal.vue?vue&type=script&lang=js&"
export * from "./RoleDeletemodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b19780",
  null
  
)

export default component.exports